// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toast_wrapper__39oVI"};